<template>
  <div id="content-container">
    <div class="panel">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        v-permission="Auth.baseNew"
        @click="addItem"
        >添加基地</el-button
      >
      <el-table :data="list" size="small" class="mt-10">
        <el-table-column
          prop="name"
          align="left"
          label="名称"
        ></el-table-column>
        <el-table-column align="left" label="创建时间">
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 1 ? 'text-success' : 'text-danger'"
            >
              {{ scope.row.status == 1 ? '已启用' : '已禁用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.baseEdit"
              :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="text" size="small">{{
                scope.row.status == 1 ? '禁用' : '启用'
              }}</el-button>
            </el-popconfirm>
            <el-button
              @click.native="editItem(scope.row, scope.$index)"
              v-permission="Auth.baseEdit"
              type="text"
              size="mini"
              class="ml-10"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <room-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></room-former>
  </div>
</template>

<script>
import { baseList, switchBaseStatus } from '@/service/getData'
import RoomFormer from './former'

export default {
  components: {
    RoomFormer,
  },
  data() {
    return {
      list: [],
      model: {
        name: '',
      },
      formerVisible: false,
      editIndex: -1,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await baseList({
        filter_blank: true,
        status: 100
      })
      if (res.status == 0) {
        this.list = res.data
      }
    },
    addItem() {
      this.model = {
        name: '',
      }
      this.formerVisible = true
    },

    editItem(item, index) {
      this.formerVisible = true
      this.$nextTick(() => {
        this.editIndex = index
        this.model = this.clone(item)
      })
    },

    async handleSwitchStatus(index, id) {
      let res = await switchBaseStatus(id)
      if (res.code == 0) {
        this.list[index].status = res.data.status
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },

    createdCallback(data) {
      this.list.push(data)
    },

    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
  },
}
</script>